/**
 * Mid-session "you've been signed out" prompt for a mutation 401 (design
 * §1.3, §6.1). The user was acting, so instead of redirecting and discarding
 * their input this raises a persistent toast with a **Sign in** action.
 *
 * Kept apart from ``lib/auth/session-expiry.ts`` because the action needs a
 * React element; the routing decision stays framework-agnostic there.
 * ``onSignIn`` is injectable because jsdom's ``window.location`` cannot be
 * stubbed.
 */

"use client"

import { ToastAction } from "@/components/ui/toast"
import { toast } from "@/hooks/use-toast"

export function showSessionExpiredToast(
  target: string,
  onSignIn?: () => void,
): void {
  const navigate = onSignIn ?? (() => window.location.assign(target))
  toast({
    duration: Infinity,
    title: "You've been signed out",
    description: "Sign in again to continue — your changes are still here.",
    action: (
      <ToastAction altText="Sign in" onClick={navigate}>
        Sign in
      </ToastAction>
    ),
  })
}
